export default __webpack_public_path__ + "resources/icons/n341-f4ed.png";